import React, { useState, useEffect, useRef } from 'react';
import InputWrapper from './InputWrapper';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

const ImageUploadHover = ({ label, value, onFileChange, error, id = 'imgInp' }) => {
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (value instanceof File) {
      const objectUrl = URL.createObjectURL(value);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(value);
    }
  }, [value]);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <InputWrapper label={label} error={error}>
      <div className="profile-upload-hover w-100" style={{ position: 'relative', display: 'inline-block' }}>
        {preview && (
          <ImageWithBaseApi
            className="img-fluid shadow rounded"
            src={preview}
            alt="Vista previa"
            height="auto"
            width="120px"
            loadingIconFontSize="30px"
          />
        )}
        <div
          className="profile-upload-hover-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0,
            transition: 'opacity 0.3s',
            cursor: 'pointer'
          }}
          onClick={handleButtonClick}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
        >
          Actualizar
        </div>
        <input
          type="file"
          accept="image/*"
          onChange={onFileChange}
          id={id}
          autoComplete="off"
          ref={fileInputRef}
          style={{ display: 'none' }}
        />
      </div> <br />
    </InputWrapper>
  );
};

export default ImageUploadHover;